import { appUrlsFromBase, resolveAppBaseUrl } from '@tailark/core/marketing'

/** Product app URL for the Farsi marketing site (env override with app.lummeny.ir fallback). */
export const APP_BASE_URL = resolveAppBaseUrl('ir')

export const config = {
    ...appUrlsFromBase(APP_BASE_URL),
} as const
